import React from "react";

const TeamPage = () => {
  const teamMembers = [
    {
      id: 3,
      name: "मा.श्री.डि.एस.कातारे पाटील",
      position: "प्रदेशाध्यक्ष ",
      image: "/team/t6.jpeg",

      bio: "Digital marketing strategist with expertise in brand growth and customer engagement.",
    },
    {
      id: 2,
      name: "मा.श्री.राजेंद तनपुरे",
      position: "खजिनदार",
      image: "/team/t3.jpeg",

      bio: "Senior developer specializing in React, Node.js, and cloud architecture solutions.",
    },

    {
      id: 1,
      name: "मा.श्री.बी.एस.बोखारे",
      position: "सरचिटणीस",
      image: "/team/t2.jpeg",

      bio: "Creative designer focused on user experience and intuitive interface design.",
    },
    {
      id: 4,
      name: "मा.श्री. चिंतामण मुंडे",
      position: "प्रदेश उपाध्यक्ष ",
      image: "/team/t9.jpeg",

      bio: "Digital marketing strategist with expertise in brand growth and customer engagement.",
    },
    {
      id: 5,
      name: "मा.श्री.पंडीतराव बोराडे",
      position: "सचिव महाराष्ट्र राज्य ",
      image: "/team/t.jpeg",
      bio: "Visionary leader with 15+ years in tech innovation and strategic business development.",
    },
    {
      id: 7,
      name: "मा.श्री.अजय आघाव",
      position: " सचिव - महाराष्ट्र राज्य",
      image: "/team/t4.jpeg",

      bio: "Digital marketing strategist with expertise in brand growth and customer engagement.",
    },
    {
      id: 9,
      name: "मा.श्री. लक्ष्मणराव कुलकर्णी ",
      position: "प्रदेश उपाध्यक्ष",
      image: "/team/t7.jpeg",

      bio: "Digital marketing strategist with expertise in brand growth and customer engagement.",
    },
    {
      id: 10,
      name: "मा.श्री. राजेभाऊ शिंदे",
      position: "युवा प्रदेशाध्यक्ष",
      image: "/team/t8.jpeg",

      bio: "Digital marketing strategist with expertise in brand growth and customer engagement.",
    },
    {
      id: 8,
      name: "मा.श्री.किशोर शिरसाट",
      position: "संपर्क प्रमुख",
      image: "/team/t1.jpeg",

      bio: "Full-stack architect passionate about scalable solutions and emerging technologies.",
    },
    {
      id: 11,
      name: "सौ.शोभाताई बोबडे",
      position: "शहराध्यक्षा नाशिक ",
      // position2: " मराठवाडा सामाजिक फाऊंडेशन",
      image: "/team/t13.jpeg",

      bio: "Product strategist driving innovation through data-driven decisions and user feedback.",
    },
    {
      id: 12,
      name: "मा.श्री. महादेवराव गायके",
      position: "प्रदेश संघटक ",
      // position2: " मराठवाडा सामाजिक फाऊंडेशन",
      image: "/team/t14.jpeg",

      bio: "Product strategist driving innovation through data-driven decisions and user feedback.",
    },
    {
      id: 13,
      name: "मा.श्री प्रमोद नजान",
      position: "शहराध्यक्ष पुणे ",
      // position2: " मराठवाडा सामाजिक फाऊंडेशन",
      image: "/team/t15.jpeg",

      bio: "Product strategist driving innovation through data-driven decisions and user feedback.",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="  text-dark text-center py-4">
        <h1 className="display-4 fs-bold mb-4 mt-4"> प्रमुख मार्गदर्शक</h1>
        <div className="row d-flex py-2 justify-content-center text-center">
          <div className="col-md-3">
            <img
              src="/images/meghana.jpg"
              className="rounded-circle "
              width={200}
              alt=""
            />
            <h4 className="mt-2 fw-bold"> सौ. मेघना साकोरे-बोर्डीकर</h4>
            <span> राज्यमंत्री,महाराष्ट्र शासन</span>
          </div>
          <div className="col-md-3">
            <img
              src="/images/karad.png"
              className="rounded-circle "
              width={200}
              alt=""
            />
            <h4 className="mt-2 fw-bold"> मा.श्री. डी. एल. कराड</h4>
            <span> राष्ट्रीय उपाध्यक्ष – CITU तथा कामगार नेते</span>
          </div>
          <div className="col-md-3">
            <img
              src="/images/pradip.png"
              className="rounded-circle"
              width={200}
              alt=""
            />
            <h4 className="mt-2 fw-bold"> मा.श्री. प्रदीप पेशकार </h4>
            <span>सदस्य, नॅशनल बोर्ड MSME , भारत सरकार </span>
          </div>{" "}
          <div className="col-md-3">
            <img
              src="/team/t11.jpeg"
              className="rounded-circle"
              width={200}
              alt=""
            />
            <h4 className="mt-2 fw-bold"> डॉ. रमेश घाडगे</h4>
            <span>
              {" "}
              एम. बी. बी. एस, एम.एस अस्थिरोग तज्ञ <br />
            </span>
          </div>
        </div>
        <div className="container mx-auto px-4 text-center">
          <h1 className="display-4 fs-bold mb-4 mt-5 py-2">
            संस्थेची कार्यकारणी{" "}
          </h1>
          {/* <p className="mx-auto">
            We're a diverse group of passionate professionals dedicated to
            creating innovative solutions and delivering exceptional results for
            our clients.
          </p> */}
        </div>
      </div>

      {/* Team Members Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="row g-4">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-lg-4 col-md-6">
              <div className="card h-100 shadow-sm border-0 team-card">
                <div className="card-body text-center p-4">
                  <div className="position-relative mb-4">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="rounded-circle img-fluid mb-3"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <h5 className="card-title font-weight-bold text-dark mb-1">
                    {member.name}
                  </h5>
                  <p className="text-primary font-weight-semibold mb-3">
                    {member.position} <br /> {member.position2}
                  </p>

                  {/* <p className="card-text text-muted mb-4 small">
                    {member.bio}
                  </p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .team-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .team-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
        }

        .display-4 {
          font-size: 2.5rem;
          font-weight: 700;
        }

        .lead {
          font-size: 1.25rem;
          font-weight: 300;
        }

        .font-weight-semibold {
          font-weight: 600;
        }

        .gap-3 {
          gap: 1rem;
        }

        .w-5 {
          width: 1.25rem;
        }

        .h-5 {
          height: 1.25rem;
        }

        @media (max-width: 768px) {
          .display-4 {
            font-size: 2rem;
          }

          .lead {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TeamPage;
